export { fromEvent } from './file-selector';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-selector/dist/es5/index.js
// module id = 1407
// module chunks = 2